<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('serviceSubscription.unsubscriptionList') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('serviceSubscription.pageTitle'),
            href: '/service-subscriptions'
          },
          {
            text: $t('serviceSubscription.unsubscriptionList'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            color="info"
            outline
            @click.prevent="$router.push({ name: 'service-subscription' })"
            >{{ $t('back') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'student.full_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td>{{ record.student.card_number }}</td>
            <td>{{ record.fee_type.fee_type_name }}</td>
            <td>{{ record.fee_setup.fee_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.unsubs_date }}</td>
            <td>{{ record.unsubs_reason }}</td>
            <td>{{ getActionUserName(record) }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.action_date }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { camelCase, debounce, mapKeys } from 'lodash'
import { Pagination } from '@/store/mixins'

export default {
  name: 'serviceUnsubscription',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: [],
      resources: [],
      pagination: new Pagination(),
      search: null,
      branch_id: []
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    columns() {
      return [
        { name: this.$t('serviceSubscription.branch') },
        { name: this.$t('serviceSubscription.cardNumber') },
        { name: this.$t('serviceSubscription.feeType') },
        { name: this.$t('serviceSubscription.feeName') },
        {
          name: this.$t('serviceSubscription.unsubscribeDate'),
          style: 'width:10%'
        },
        { name: this.$t('serviceSubscription.unsubscribeReason') },
        { name: this.$t('serviceSubscription.actionBy') },
        {
          name: this.$t('serviceSubscription.createdDate'),
          style: 'width:10%'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'serviceSubscription/fetchUnsubscriptions',
          Object.assign(
            {
              page: this.pagination.currentPage,
              perPage: this.pagination.perPage,
              search: this.search,
              branch_id: this.branch_id,
              all_branch: Array.isArray(this.branch_id)
                ? this.branch_id.length
                  ? undefined
                  : true
                : true
            },
            { ...attributes }
          )
        )
        .then(response => {
          this.resources = response.data
          this.pagination = new Pagination(
            mapKeys(response.meta, (value, key) => camelCase(key))
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    getActionUserName(record) {
      if (!record.action_user) {
        return ''
      }

      return record.action_user.employee
        ? record.action_user.employee.name_en
        : record.action_user.loginname
    }
  },
  watch: {
    search: debounce(function(search) {
      this.pagination.currentPage = 1
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.pagination.currentPage = 1
      this.fetchData({ branch_id: value })
    }, 500)
  }
}
</script>
